let Awards = {
    initSlider: function(slider){
        slider.slick({
            infinite: false,
            adaptiveHeight: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            pauseOnHover: false,
            pauseOnFocus: false,
            autoplay: false,
            speed: 1200,
            fade: false,
            arrows: true,
            dots: false,
            prevArrow: '<div class="btn-arrow btn-arrow_left">'+
                            '<span class="svg-icon">'+
                                '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                            '</span>'+
                        '</div>',
            nextArrow: '<div class="btn-arrow">'+
                            '<span class="svg-icon">'+
                                '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                            '</span>'+
                        '</div>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 599,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }
}

$(document).ready(function($) {

    let awardsSlider = $('[data-awards-slider]');
    if(awardsSlider.length){
        Awards.initSlider(awardsSlider);
    }
});


// WEBPACK FOOTER //
// ./components/awards.js